"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlackClient = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const authenticated_client_1 = require("./authenticated.client");
class SlackClient extends authenticated_client_1.AuthenticatedClient {
    getConversationsByProjectId(projectId, options) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const limit = 'limit='.concat(((_a = options === null || options === void 0 ? void 0 : options.limit) === null || _a === void 0 ? void 0 : _a.toString()) || '');
            const cursor = 'cursor='.concat((options === null || options === void 0 ? void 0 : options.cursor) || '');
            const queryString = '?'.concat(limit, '&', cursor);
            const response = yield this.httpGet(`${this.baseUrl(projectId)}/conversations${queryString}`);
            return response.payload;
        });
    }
    createMessageConfiguration(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`${this.baseUrl(params.projectId)}/message-configurations`, (0, lodash_1.omit)(params, ['projectId']));
            return response.payload;
        });
    }
    getMessageConfById(projectId, messageConfId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`${this.baseUrl(projectId)}/message-configurations/${messageConfId}`);
            return response.payload;
        });
    }
    getMessageConfigurations(projectId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = filters ? `?entityType=${filters.entityType}&entityId=${filters.entityId}` : '';
            const { payload } = yield this.httpGet(`${this.baseUrl(projectId)}/message-configurations${queryString}`);
            return payload;
        });
    }
    updateMessageConfiguration(projectId, updatePayload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpPut(`${this.baseUrl(projectId)}/message-configurations/${updatePayload.id}`, updatePayload);
            return payload;
        });
    }
    deleteMessageConfigurationById(projectId, messageConfId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`${this.baseUrl(projectId)}/message-configurations/${messageConfId}`);
            return response.payload;
        });
    }
    baseUrl(projectId) {
        return `/v1/projects/${projectId}/slack`;
    }
}
exports.SlackClient = SlackClient;
//# sourceMappingURL=slack.client.js.map